import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';

@Component({
  selector: 'app-return-modal',
  templateUrl: './return-modal.component.html',
  styleUrls: ['./return-modal.component.css'],
})
export class ReturnModalComponent implements OnChanges {
  constructor(
    private logger: LoggerService,
    private modalService: NgbModal,
    private apiService: UserApiService
  ) {}

  @ViewChild('factorReturnModal') modalContent!: any;

  @Input() saleFactorId?: string;

  public factor: any;

  public loading: boolean = true;

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => {}
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['saleFactorId'] &&
      changes['saleFactorId'].currentValue !== undefined
    ) {
      this.loading = true;
      this.openModal();
      this.getData();
    } else {
      this.modalService.dismissAll();
    }
  }

  public getData() {
    try {
      if (this.saleFactorId==null||this.saleFactorId=="") {
        this.loading=false;
        return;
      }

      const endPointUrl = `SaleFactor/Details/${this.saleFactorId}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(endPointUrl))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(endPointUrl, result, `Get Single Item`);
          if (result.succeeded) {
            this.factor=result.data;
          }else{
            this.modalService.dismissAll();
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }
}
